import React from "react"
import Button from "@mui/material/Button"
import { DateTime } from "luxon"
import store from "@/store"
import i18n from "@/i18n"

const CalendarToday: React.FC = () => {
  const { currentDate, setCurrentDate } = store
  const today = DateTime.now().setZone(currentDate.zoneName)

  const isTodaySelected =
    currentDate.hasSame(today, "day") && currentDate.hasSame(today, "month") && currentDate.hasSame(today, "year")

  const onToday = () => setCurrentDate(today)

  return (
    <Button
      variant="ui-element"
      className="h-8 px-5 text-nowrap rounded-[5px] !border-[#eee] !text-xs"
      color="inherit"
      onClick={onToday}
      disabled={isTodaySelected}
      data-testid="calendar-today"
    >
      <span className="text-neutral-900">{i18n.t("app.reservations_navigation.today")}</span>
    </Button>
  )
}

export default CalendarToday
